<template>
  <b-modal id="phone-modal" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Phone Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.phone_number)" v-model="input_data.phone_number" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.phone_type" v-model="input_data.phone_type" :reduce="phone_type=>phone_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.desc"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status change by employee</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Status change
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"

import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "PhoneInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        phone_number:"",
        phone_type:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        phone_type:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:"false"}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    onSubmit(){
      let payload = {
        emp_id:this.$store.getters.empId,
        phone_number : this.input_data.phone_number,
        phone_phonetype_id : this.input_data.phone_type,
        phone_desc : this.input_data.desc,
        status: this.input_data.status == 'active' ? 1:0,
        user_id:this.$store.getters.userId
      }
      if (this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.phone.update).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else {
        AxiosCall.Post(payload, urlApi.phone.add).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }

    },
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title = "Edit"
          this.input_data = {
            phone_number:this.data.number,
            phone_type:this.data.type_id,
            desc:this.data.desc,
            status:(this.data.status == 1 ? 'active': 'non_active'),
            default:(this.data.is_default == 1 ? true : false),
            is_locked:"accepted"
          }
        }
      }, 100)
    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.title = "Add"
      this.$parent.data = null
      this.input_data = {
        phone_number:"",
        phone_type:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      }
    },
    getType(){
      this.options.phone_type = []
      AxiosCall.Get({}, urlApi.phone.type).then(res=>{
        if(res.success){
          this.options.phone_type = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    this.getType()
  }
}
</script>